	
export default {
  props: {
    onRefresh: {
      type: Function,
      required: false
    },
	title:{
		type:String
	},
	ispc:{
		type:Boolean
	},
	isrefresh:{
		type:Boolean
	}
  },
  data () {
    return {
      defaultOffset: 50, // 默认高度, 相应的修改.releshMoudle的margin-top和.down-tip, .up-tip, .refresh-tip的height
      top: 0,
      scrollIsToTop: 0,
      startY: 0,
      isDropDown: false, // 是否下拉
      isRefreshing: false, // 是否正在刷新
      dropDownState: 1, // 显示1:下拉可以刷新, 2:松开立即刷新, 3:正在刷新数据中...
      dropDownInfo: {
        downText: '下拉可以刷新',
        downImg: 'arrow.png',
        upText: '松开立即刷新',
        upImg: 'arrow.png',
        refreshText: '正在刷新数据...',
        refreshImg: 'loading.png'
      }
    }
  },
  created () {
    if (document.querySelector('.refresh-moudle')) {
      // 获取不同手机的物理像素（dpr）,以便适配rem
      this.defaultOffset = document.querySelector('.refresh-moudle').clientHeight || this.defaultOffset
    }
  },
  methods: {
    /**
     * 触摸开始，手指点击屏幕时
     * @param {object} e Touch 对象包含的属性
     */
    touchStart (e) {	
      this.startY = e.targetTouches[0].pageY;
	  //console.log(this.startY)
    },

    /**
     * 接触点改变，滑动时
     * @param {object} e Touch 对象包含的属性
     */
    touchMove (e) {		
		if(this.isrefresh){
			this.scrollIsToTop = document.documentElement.scrollTop || window.pageYOffset || document.body.scrollTop // safari 获取scrollTop用window.pageYOffset
			if (e.targetTouches[0].pageY > this.startY) {
			  // 下拉
			  this.isDropDown = true
			  if (this.scrollIsToTop === 0 && !this.isRefreshing) {
			    // 拉动的距离
			    let diff = e.targetTouches[0].pageY - this.startY - this.scrollIsToTop
			    this.top = Math.pow(diff, 0.8) + (this.dropDownState === 3 ? this.defaultOffset : 0)
			    if (this.top >= this.defaultOffset) {
			      this.dropDownState = 2
			      e.preventDefault()
			    } else {
			      this.dropDownState = 1
			      // 去掉会导致ios无法刷新
			      e.preventDefault()
			    }
			  }
			} else {
			  this.isDropDown = false
			  this.dropDownState = 1
			}
		}
     
    },

    /**
     * 触摸结束，手指离开屏幕时
     * @param {object} e Touch 对象包含的属性
     */
    touchEnd (e) {
      if (this.isDropDown && !this.isRefreshing) {
        if (this.top >= this.defaultOffset) {
          // do refresh
          this.refresh()
          this.isRefreshing = true
        } else {
          // cancel refresh
          this.isRefreshing = false
          this.isDropDown = false
          this.dropDownState = 1
          this.top = 0
        }
      }
    },

    /**
     * 刷新
     */
    refresh () {
      this.dropDownState = 3
      this.top = this.defaultOffset
      // 这是全是静态数据,延时1200毫秒，给用户一个刷新的感觉，如果是接口数据的话，直接调接口即可
      setTimeout(() => {
        this.onRefresh(this.refreshDone)
      }, 1200)
    },

    /**
     * 刷新完成
     */
    refreshDone () {
      this.isRefreshing = false
      this.isDropDown = false
      this.dropDownState = 1
      this.top = 0
    }
  }
}
